export default class User {
  constructor(public username: string, public centre: string, public role: string) { }
}
